import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Catch } from '../shared/catch.model';
import { LocalStorageService } from '../shared/local-storage.service';
import { FishingEvent } from '../shared/fishing-event.model';
import { TrawlSet } from '../shared/trawl-set.model';


enum Fishery {Groundfish = "GF", HMS = "HMS", Trawl = "Trawl"};

/**
 * A formatted table detailing all catch on a set or on all sets attached to a delivery.
 */
@Component({
    selector: 'app-summary-report',
    templateUrl: './summary-report.component.html',
    styleUrls: ['./summary-report.component.css'],
    standalone: false
})
export class SummaryReportComponent implements OnInit, OnDestroy {

  @ViewChild(MatTable) table!: MatTable<Catch>;
  catchItems: Catch[] = [];
  catchTableColumns: string[] = ['Species', 'RetainedCount', 'RetainedWeight', 'ReleasedCount', 'ReleasedWeight'];
  title: string = '';
  dataSubscription!: Subscription;
  fishery: string = '';



  constructor(private route: ActivatedRoute, public router: Router) { }

  /**
   * This page can be navigated to from: set list, current delivery, or a completed delivery.
   * We get all recorded catch and put it into the table.
   */ 
  ngOnInit(): void {
    LocalStorageService.storage_promise.then(result => { 
      let index = Number.parseInt(<string>this.route.snapshot.paramMap.get('index'));
      this.updateTable();
      if (<string>this.route.snapshot.paramMap.get('delivery') == 'true') {
        if (index == -1) this.dataSubscription = LocalStorageService.user_trip$.subscribe(_ => this.updateTable());
      } else {
        this.dataSubscription = LocalStorageService.user_trip$.subscribe(_ => this.updateTable());
      }
    });
    
  }


  updateTable() {
    let species = new Map<string, Catch>();
    let index = Number.parseInt(<string>this.route.snapshot.paramMap.get('index'));
    let isDraft = this.route.snapshot.queryParams.draft == 'true';
    let sets: (FishingEvent | TrawlSet)[] = [];
    this.catchItems = [];

    this.fishery = <string>this.route.snapshot.paramMap.get('delivery');

    if (this.fishery == 'menu') {
      let from = this.route.snapshot.queryParams.from;
      this.title = 'All Sets';
      this.fishery = from == 0 ? 'Groundfish' : from == 1 ? 'HMS' : 'Trawl';
      sets = from == 2 ? LocalStorageService.user_trawlTrip.sets : LocalStorageService.user_trip.sets.filter(s => s.fishery == this.fishery);
      
    } else if (this.fishery == 'Trawl') {
      let delivery = LocalStorageService.received_trawlLogbooks[index];
      let logbook = LocalStorageService.edited_trawlLogbook;

      this.title = index == -1 ? 'Current Trawl Delivery' : "Logbook " + LocalStorageService.received_trawlLogbooks[index].logbookId.substring(17);
      sets = index == -1 ? LocalStorageService.user_trawlTrip.trawlDelivery.sets : (delivery.logbookId == logbook.logbookId) ? logbook.sets : delivery.sets;
      
    } else {
      let delivery = isDraft ? LocalStorageService.hms_drafts[index] : LocalStorageService.received_logbooks[index];
      let logbook = LocalStorageService.edited_logbook.GF.logbookId ? LocalStorageService.edited_logbook.GF : LocalStorageService.edited_logbook.HMS;

      
      this.title = index == -1 ? `Current ${this.fishery} Delivery` : isDraft ? 'Draft Trip' : "Logbook " + LocalStorageService.received_logbooks[index].logbookId.substring(17);
      sets = index == -1 ? (this.fishery == 'Groundfish' ? LocalStorageService.user_trip.groundfishDelivery.sets : 
      LocalStorageService.user_trip.hmsDelivery.sets) : isDraft ? LocalStorageService.hms_drafts[index].sets : (delivery.logbookId == logbook.logbookId) ? logbook.sets : delivery.sets;
    }


    sets.forEach(set => {
      set.catchItems.forEach(cth => {
        //These need to be numbers but are being interpreted as strings?
        if (species.has(cth.species.name)) {
          let c = species.get(cth.species.name);
          if (c?.releasedCount) c!.releasedCount +=  cth.releasedCount ?? 0;
          if (c?.retainedCount) c!.retainedCount += cth.retainedCount ?? 0;
          if (c?.releasedWeight) c!.releasedWeight += cth.releasedWeight ?? 0;
          if (c?.retainedWeight) c!.retainedWeight += cth.retainedWeight ?? 0;
          species.set(c!.species.name, c!);
        } else {
          species.set(cth.species.name, Catch.transformAnonymous([cth])[0]);
        }
      });
    });
    console.log(species)
    species.forEach(pair => {
      this.catchItems.push(pair);
    });
    this.table.renderRows();
  }


  navigateBack() {
    let index = Number.parseInt(<string>this.route.snapshot.paramMap.get('index'));
    let isDraft = this.route.snapshot.queryParams.draft == 'true';

    const deliveryType = <string>this.route.snapshot.paramMap.get('delivery');
    const deliveryDetailRoute = deliveryType === 'menu' ? 'menu' : 
                                deliveryType === 'Trawl' ? 'trawl_delivery' : 
                                deliveryType === 'Groundfish' ? 'delivery_detail' : 'hms_delivery_detail';
    const logbook = deliveryType === 'Trawl' ? LocalStorageService.edited_trawlLogbook : 
                    deliveryType === 'Groundfish' ? LocalStorageService.edited_logbook.GF : LocalStorageService.edited_logbook.HMS;

    if (index != -1) {
      let delivery = deliveryType === 'Trawl' ? LocalStorageService.received_trawlLogbooks[index] : LocalStorageService.received_logbooks[index];
      this.router.navigate([deliveryDetailRoute, isDraft ? 3 : delivery.logbookId == logbook.logbookId ? 2 : 1, index], { queryParams: { previous: 'deliveries_list' } });
    } else {
      this.router.navigate([deliveryDetailRoute, 0, -1], { queryParams: { previous: 'menu' } });
    }

  }

  ngOnDestroy(): void {
    if (this.dataSubscription) this.dataSubscription.unsubscribe();
  }
}
